import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import ImgPath from "../../Constants/Imgs";

const whyUsData = [
  {
    title: "Affordable Professional Services",
    description: "Proven legal and financial solutions with senior experts.",
    img: ImgPath.APSIcon,
  },
  {
    title: "Diverse Expert Network",
    description:
      "Talk to lawyers, chartered accountants (CAs), and company secretaries (CSs) to meet your legal and financial needs.",
    img: ImgPath.DENIcon,
  },
  {
    title: "Easy-to-use dashboard",
    description: "Streamlined navigation for service requests and tracking.",
    img: ImgPath.EasyToUseIcon,
  },
  {
    title: "Quick Customer Support",
    description: "Queries are responded within 24 hours*",
    img: ImgPath.QCSIcon,
  },
];

const WhyUsSection = () => {
  return (
    <Box sx={{ py: 8, bgcolor: "#a24857" }}>
      <Box sx={{ maxWidth: 1200, mx: "auto", px: 2 }}>
        <Typography
          variant="h4"
          align="center"
          sx={{
            color: "#fff",
            fontWeight: 700,
            mb: 5,
            fontFamily: "'Playfair Display', serif",
          }}
        >
          Why Us?
        </Typography>

        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="stretch"
        >
          {whyUsData.map((item, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  p: 3,
                  borderRadius: 2,
                  height: "100%",
                  boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={item.img}
                  alt={item.title}
                  sx={{
                    width: 60,
                    height: 60,
                    objectFit: "contain",
                    mr: 3,
                  }}
                />
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, color: "#a24857", mb: 1 }}
                  >
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#333" }}>
                    {item.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default WhyUsSection;
